<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_iv"></a></p>
<p class="copyright">Copyright © 2008 by Toni Sepeda and Diogenes Verlag AG, Zurich</p>
<p class="copyright">Introduction copyright © 2008 by Donna Leon and Diogenes Verlag AG, Zurich</p>
<p class="copyright">Copyright © 2008 for all the maps to the twelve city tours by Falk Verlag D-Ostfildern</p>
<p class="copyright">Copyright © 2008 for the lagoon map by Laguna Veneta, Edizione Garbizza, Castello 5314, 30122 Venezia</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copyright">Originally published in German in 2008 by Diogenes Verlag AG, Zurich First published in English in 2009 by William Heinemann, Random House, London</p>
<p class="copyright"><em>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="copyright">eBook ISBN-13: 978-0-8021-9984-3</p>
<p class="copyright">Grove Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003<br/>Distributed by Publishers Group West<br/><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0f7625e0